'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Content;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Interests = require('./Interests');

var _Skills = require('./Skills');

var _Education = require('./Education');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getContent = function getContent(currentTab, _ref) {
  var interests = _ref.interests,
      skills = _ref.skills,
      showMore = _ref.showMore,
      showMoreInterests = _ref.showMoreInterests,
      education = _ref.education;

  if (currentTab === 'interests') {
    return _react2.default.createElement(_Interests.Interests, {
      interests: interests,
      showMore: showMore,
      showMoreInterests: showMoreInterests
    });
  } else if (currentTab === 'skills') {
    return _react2.default.createElement(_Skills.Skills, {
      skills: skills
    });
  } else if (currentTab === 'education') {
    return _react2.default.createElement(_Education.Education, {
      levels: education.levels,
      user: education.user,
      preferred: education.preferred,
      required: education.required
    });
  }

  return _react2.default.createElement(
    'div',
    null,
    'No tab for ',
    currentTab
  );
};

function Content(_ref2) {
  var currentTab = _ref2.currentTab,
      interests = _ref2.interests,
      skills = _ref2.skills,
      showMore = _ref2.showMore,
      showMoreInterests = _ref2.showMoreInterests,
      education = _ref2.education;

  return _react2.default.createElement(
    'div',
    { className: 'job_match_content' },
    getContent(currentTab, {
      interests: interests,
      skills: skills,

      showMore: showMore,
      showMoreInterests: showMoreInterests,

      education: education
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobMatch/Content/Content.jsx
// module id = 1188
// module chunks = 0